import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { IS_B2B_BIZ_USER, IS_CHOSEN_PUBLIC_FILE, IS_REACT_PAGE, LOGO_SRC } from 'reactApp/appHelpers/configHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { useHref } from 'reactApp/ui/Header/Logo/Logo.hooks';
import { ELogoSize, LogoComponent } from 'reactApp/ui/Header/Logo/LogoComponent';

export const Logo = memo(({ white = false }: { white?: boolean }) => {
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    const size = IS_CHOSEN_PUBLIC_FILE ? ELogoSize.s : ELogoSize.m;
    const storage = useSelector(getCurrentStorage);
    const { isAllDocuments, isIntegration } = getStorage(storage);
    const useRouterLink = IS_REACT_PAGE;
    const isBiz = IS_B2B_BIZ_USER;
    const href = useHref(storage, useRouterLink, isBiz);

    return (
        <LogoComponent
            isPhone={isPhone}
            white={white}
            logoSrc={LOGO_SRC}
            isBiz={isBiz}
            size={size}
            useRouterLink={useRouterLink}
            isDocuments={isAllDocuments}
            href={href}
            withEndorsement={!isAllDocuments && !isIntegration}
        />
    );
});

Logo.displayName = 'Logo';
